<template>
  <section class="contact" id="contacto">
    <div class="content">
      <div class="left">
        <h2 class="headline">
          <span class="thin">¡SÍGUENOS EN NUESTRAS</span>
          <span class="bold">REDES SOCIALES!</span>
        </h2>

        <div class="social">
          <a
            class="social-btn"
            href="https://www.facebook.com/profile.php?id=100091148102992"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            title="Facebook"
          >
            <i class="bi bi-facebook" aria-hidden="true"></i>
          </a>

          <a
            class="social-btn"
            href="https://www.instagram.com/mycard_colombia/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            <i class="bi bi-instagram" aria-hidden="true"></i>
          </a>

          <a
            class="social-btn"
            href="https://www.linkedin.com/company/93355708/admin/feed/posts/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn"
          >
            <i class="bi bi-linkedin" aria-hidden="true"></i>
          </a>

        </div>
      </div>

      <div class="right">
        <div class="map-wrap" aria-label="Mapa de ubicación">
          <iframe
            class="map-iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.434715364366!2d-74.07006888944218!3d4.694281195261028!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9adafb5695cf%3A0xe5a84bd7254bf6d7!2sEdificio%20Excalibur!5e0!3m2!1ses!2sco!4v1769701298746!5m2!1ses!2sco"
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="Ubicación MyCard"
          ></iframe>
        </div>

        <p class="below-map">¡Puedes encontrarnos aquí!</p>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "ContactSection" };
</script>

<style scoped>
.contact {
  background: #050505;
  padding: 110px 0;
  scroll-margin-top: 90px;
  margin: 0;
}

.content {
  width: min(1200px, 92%);
  margin: 0 auto;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(28px, 5vw, 70px);
  align-items: center;
}

.left {
  padding-left: clamp(0px, 2vw, 30px);
}

.headline {
  margin: 0 0 36px 0;
  color: #fff;
  line-height: 1.05;
  letter-spacing: 0.02em;
}

.headline .thin {
  display: block;
  font-family: "Exo", sans-serif;
  font-weight: 300;
  font-size: clamp(18px, 2.2vw, 34px);
  opacity: 0.95;
}

.headline .bold {
  display: block;
  font-family: "Exo", sans-serif;
  font-weight: 900;
  font-size: clamp(34px, 4.6vw, 72px);
}

.social {
  display: flex;
  align-items: center;
  gap: clamp(18px, 2.6vw, 34px);
}

.social-btn {
  width: clamp(72px, 6.2vw, 92px);
  height: clamp(72px, 6.2vw, 92px);
  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  background: #ffffff;
  color: #0b0b0b;
  text-decoration: none;


  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);

  transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
  opacity: 0.98;
}

.social-btn i {
  font-size: clamp(34px, 3vw, 44px);
  line-height: 1;
}

.social-btn:hover {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 26px 70px rgba(0, 0, 0, 0.65);
  opacity: 1;
}

.right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.map-wrap {
  width: min(620px, 100%);
  height: clamp(260px, 22vw, 360px);
  background: #000;

  border-radius: 8px;
  overflow: hidden;

  box-shadow: 0 28px 90px rgba(0, 0, 0, 0.65);

  transform: translateY(6px);
  opacity: 0.98;
  animation: fadeUp 520ms ease both;
}

.map-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.below-map {
  margin: 18px 0 0 0;
  color: rgba(255, 255, 255, 0.92);
  font-family: "Exo", sans-serif;
  font-weight: 300;
  font-size: clamp(20px, 2.2vw, 34px);
  text-align: center;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 0.98;
    transform: translateY(6px);
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .contact {
    padding: 70px 0;
  }

  .content {
    grid-template-columns: 1fr;
    gap: 34px;
    align-items: stretch;
  }

  .left {
    text-align: center;
  }

  .social {
    justify-content: center;
  }

  .headline .thin {
    font-size: clamp(18px, 2.4vw, 26px);
  }

  .headline .bold {
    font-size: clamp(34px, 4.6vw, 56px);
  }

  .map-wrap {
    width: 100%;
    height: 300px;
  }
}

@media (max-width: 767px) {
  .contact {
    padding: 44px 0;
  }

  .content {
    grid-template-columns: 1fr;
    gap: 26px;
  }

  .left {
    padding-left: 0;
    text-align: center;
  }

  .social {
    justify-content: center;
    gap: 18px;
    flex-wrap: wrap;
  }

  .map-wrap {
    height: 230px;
    width: 100%;
    border-radius: 10px;
  }

  .below-map {
    margin-top: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .map-wrap {
    animation: none;
    transform: none;
  }
  .social-btn {
    transition: none;
  }
}
</style>
